// extracted by mini-css-extract-plugin
module.exports = {"container":"ViewKick_container__RxWJU","dialogContainer":"ViewKick_dialogContainer__1Vpup","content":"ViewKick_content__1gQya","details":"ViewKick_details__2K0nE"};